<template>
  <section id="global-partnership">
    <div class="container">
      <p class="title" v-t="'global-partnership.title'"></p>
      <p class="sub-title" v-t="'global-partnership.sub-title'"></p>
    </div>

    <div class="container-partners">
      <div class="row-1 rows">
        <div class="wrapper hover-enlarge mu">
          <img src="https://doo-prime-static.oss-cn-hongkong.aliyuncs.com/doo/Home/partners/MU.png" alt="mu-logo"
            class="mu-logo" />
        </div>
        <div class="wrapper hover-enlarge adelaide">
          <img src="https://doo-prime-static.oss-cn-hongkong.aliyuncs.com/doo/Home/partners/AUFC.png" alt="adelaide"
            class="adelaide-logo" />
        </div>
        <div class="wrapper hover-enlarge morning-star">
          <img src="https://doo-prime-static.oss-cn-hongkong.aliyuncs.com/doo/Home/partners/Morningstar.png"
            alt="morning-star" class="morning-star-logo" />
        </div>
        <div class="wrapper hover-enlarge refinitiv">
          <img src="https://doo-prime-static.oss-cn-hongkong.aliyuncs.com/doo/Home/partners/Refinitiv.png" alt="refinitiv"
            class="refinitiv-logo" />
        </div>
        <div class="wrapper hover-enlarge bloomberg">
          <img src="https://doo-prime-static.oss-cn-hongkong.aliyuncs.com/doo/Home/partners/Bloomberg.png"
            alt="bloomberg-logo" class="bloomberg-logo" />
        </div>
        <div class="wrapper hover-enlarge ifast">
          <img src="https://doo-prime-static.oss-cn-hongkong.aliyuncs.com/doo/Home/partners/iFast.png" alt="ifast"
            class="ifast-logo" />
        </div>
        <div class="wrapper hover-enlarge bison">
          <img src="https://doo-prime-static.oss-cn-hongkong.aliyuncs.com/doo/Home/partners/BisonBank.png" alt="bison"
            class="bison-logo" />
        </div>
        <div class="wrapper hover-enlarge axa">
          <img src="https://doo-prime-static.oss-cn-hongkong.aliyuncs.com/doo/Home/partners/AXA.png" alt="axa"
            class="axa-logo" />
        </div>
        <div class="wrapper hover-enlarge cpic">
          <img src="https://doo-prime-static.oss-cn-hongkong.aliyuncs.com/doo/Home/partners/CPIC.png" alt="cpic-logo"
            class="cpic-logo" />
        </div>
        <div class="wrapper hover-enlarge zurich">
          <img src="https://doo-prime-static.oss-cn-hongkong.aliyuncs.com/doo/Home/partners/Zurich.png" alt="zurich"
            class="zurich-logo" />
        </div>
        <div class="wrapper hover-enlarge cloudfare">
          <img src="https://doo-prime-static.oss-cn-hongkong.aliyuncs.com/doo/Home/partners/Cloudflare.png" alt="cloudfare"
            class="cloudfare-logo" />
        </div>
        <div class="wrapper hover-enlarge equinix">
          <img src="https://doo-prime-static.oss-cn-hongkong.aliyuncs.com/doo/Home/partners/Equinix.png" alt="equinix"
            class="equinix-logo" />
        </div>
      </div>
    </div>
    <div class="carousel-container">
      <div class="carousel">
        <carousel :items-to-show="1" :autoplay="5000" :wrap-around="true">
          <slide key="1" class="carousel-item">
            <div class="wrapper">
              <img src="https://doo-prime-static.oss-cn-hongkong.aliyuncs.com/doo/Home/partners/MU.png" alt="mu-logo"
                class="mu-logo" />
            </div>
            <div class="wrapper">
              <img src="https://doo-prime-static.oss-cn-hongkong.aliyuncs.com/doo/Home/partners/AUFC.png" alt="adelaide"
                class="adelaide-logo" />
            </div>
            <div class="wrapper">
              <img src="https://doo-prime-static.oss-cn-hongkong.aliyuncs.com/doo/Home/partners/Morningstar.png"
                alt="morning-star" class="morning-star-logo" />
            </div>
            <div class="wrapper">
              <img src="https://doo-prime-static.oss-cn-hongkong.aliyuncs.com/doo/Home/partners/Refinitiv.png"
                alt="refinitiv" class="refinitiv-logo" />
            </div>
          </slide>
          <slide key="2" class="carousel-item">
            <div class="wrapper">
              <img src="https://doo-prime-static.oss-cn-hongkong.aliyuncs.com/doo/Home/partners/Bloomberg.png"
                alt="bloomberg-logo" class="bloomberg-logo" />
            </div>
            <div class="wrapper">
              <img src="https://doo-prime-static.oss-cn-hongkong.aliyuncs.com/doo/Home/partners/iFast.png" alt="ifast"
                class="ifast-logo" />
            </div>
            <div class="wrapper">
              <img src="https://doo-prime-static.oss-cn-hongkong.aliyuncs.com/doo/Home/partners/BisonBank.png" alt="bison"
                class="bison-logo" />
            </div>
            <div class="wrapper">
              <img src="https://doo-prime-static.oss-cn-hongkong.aliyuncs.com/doo/Home/partners/AXA.png" alt="axa"
                class="axa-logo" />
            </div>
          </slide>
          <slide key="3" class="carousel-item">
            <div class="wrapper">
              <img src="https://doo-prime-static.oss-cn-hongkong.aliyuncs.com/doo/Home/partners/CPIC.png" alt="cpic-logo"
                class="cpic-logo" />
            </div>
            <div class="wrapper">
              <img src="https://doo-prime-static.oss-cn-hongkong.aliyuncs.com/doo/Home/partners/Zurich.png" alt="zurich"
                class="zurich-logo" />
            </div>
            <div class="wrapper">
              <img src="https://doo-prime-static.oss-cn-hongkong.aliyuncs.com/doo/Home/partners/Cloudflare.png"
                alt="cloudfare" class="cloudfare-logo" />
            </div>
            <div class="wrapper">
              <img src="https://doo-prime-static.oss-cn-hongkong.aliyuncs.com/doo/Home/partners/Equinix.png" alt="equinix"
                class="equinix-logo" />
            </div>
          </slide>

          <template #addons>
            <navigation />
            <pagination />
          </template>
        </carousel>
      </div>
    </div>
  </section>
</template>

<script setup>
import { Carousel, Slide, Pagination, Navigation } from "vue3-carousel";
</script>

<style lang="less">
@import '../../less/mediaQuery.less';
#global-partnership {
  background-image: url("https://doo-prime-static.oss-cn-hongkong.aliyuncs.com/doo/Home/Partners.png");
  background-repeat: no-repeat;
  background-position: center center;
  padding-bottom: 100px;
  background-size: cover;
  max-width: 2560px;
  margin: 0 auto;

  @media @mobile-screen {
    padding-bottom: 80px;

  }

  .container {
    @media @mobile-screen {
      padding: 0 16px;
    }

    .title {
      padding-top: 160px;

      font-size: 48px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: center;
      color: #3e3a39;
      margin-bottom: 24px;

      @media @mobile-screen {
        padding-top: 80px;
        margin-bottom: 16px;
        font-size: 28px;
      }

      @media only screen and (max-width: 500px) {
        font-size: 28px;
      }
    }

    .sub-title {

      font-size: 16px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: normal;
      text-align: center;
      color: #3e3a39;
      max-width: 910px;
      margin: auto;
      margin-bottom: 80px;
      @media @mobile-screen {
        margin-bottom: 40px;
        width: auto;
      }
    }
  }

  .container-partners {
    max-width: 1330px;
    margin: auto;
    padding: 0 16px;

    @media @mobile-screen {
      display: none;
    }

    .wrapper {
      border-top: 4px solid red;
      width: 314px;
      height: 128px;
      background-color: #fff;
      display: inline-block;
      margin: 0 12px 24px;
      position:relative;

      img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }

    .rows {
      margin: 0 -27px;

      .last {
        @media only screen and (max-width: 1342px) {
          display: none;
        }
      }
    }

    .last-row {
      .wrapper {
        margin-bottom: 0;
      }
    }

    .tablet-mobile {
      display: none;

      @media only screen and (max-width: 1342px) {
        display: flex;
        align-items: center;
      }
    }
  }

  .carousel-container {
    padding: 0 16px;

    .carousel {
      display: none;
      width: 100%;

      @media @mobile-screen {
        display: block;
      }

      li.carousel__slide {
        @media @mobile-screen {
          margin-bottom: 13px;
        }
      }

      .wrapper {
        width: 100%;
        border-top: 4px solid red;
        background-color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top: 24px;
        padding-bottom: 24px;
        margin-bottom: 19px;
        @media @mobile-screen {
          max-width: 314px;
          margin-bottom: 19px;
        }
      }

      .carousel-item {
        width: 100%;
        display: flex;
        flex-direction: column;
        column-gap: 19px;
      }
    }
  }


  .carousel__pagination-button::after {
    width: 6px;
    height: 6px;
  }

  .carousel__pagination-button--active::after {
    background-color: #e03323;
  }

  .carousel__prev,
  .carousel__next {
    display: none;
  }

  .carousel__pagination {
    margin: 0 !important;
    padding: 0 !important;
  }
}
</style>
